export const ApprovedCircled = ({ className }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.25"
        y="0.25"
        width="47.5"
        height="47.5"
        rx="23.75"
        stroke="#13EF00"
        strokeWidth="0.5"
      />
      <g clipPath="url(#clip0_1277_3209)">
        <path
          d="M20.2501 24.75L22.5001 27L27.7501 21.75"
          stroke="#13EF00"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.0001 33C28.9706 33 33.0001 28.9706 33.0001 24C33.0001 19.0294 28.9706 15 24.0001 15C19.0295 15 15.0001 19.0294 15.0001 24C15.0001 28.9706 19.0295 33 24.0001 33Z"
          stroke="#13EF00"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1277_3209">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12.0001 12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
